import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import '../css/dataTables.css';
const momentTz = require('moment-timezone');
const objectCode = (param) =>{
    let name = param;
         switch (param) {
            case '17':
                name = "Orden venta";
                break;
            case '15':
                name = "Entregas";
                break;
            case '13':
                name = "Factura";
                break;
            case '16':
                name = "Devolución";
                break;
            case '21':
                name = "purchaseReturn";
                break;
            case '24':
                name = "Pago";
                break;
            case '67':
                name = "transfers";
                break;
            case '1250000001':
                break;
            case '59':
                name = "transfersEntry";
                break;
            case '60':
                name = "transfersOutput";
                break;
            case '14':
                name = "Nota de crédito";
                break;
            case '22':
                name = "PurchaseOrder";
                break;
            case '20':
                name = "GoodsReceipt";
                break;
            case '1470000113':
                name = "PurchaseRequest";
                break;
            case '162':
                name = "inventoryRevaluation";
                break;
            
            case '18':
                name = "purchaseInvoice";
                break;
            case '30':
                name = "outgoingPayment";
                break;
        }
    return name;
}

const renderTableBody = (headers, data, action) => {
    let body: "";
    
    body = data.map((transaction, index) => {

        return (
            <tr key={index}>
                {/* <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>
                    {objectCode(transaction.TransType) == 'Pago' &&
                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                                // onClick={() => openDetailsTransaction({BaseRef: transaction.BaseRef, index})}
                                style={{fontWeight: '500'}}>
                            <i className="far fa-file-alt">
                            </i> Ver
                        </button>
                    }
                    </td> */}
               
                <td>{objectCode(transaction.TransType) || ""}</td>
                <td>{transaction.CreatedBy || ""}</td>
                <td>{transaction.BaseRef || ""}</td>
                <td>{momentTz(transaction.DueDate).utc().format('DD/MM/YYYY') || ""}</td>
                <td>{momentTz(transaction.RefDate).utc().format('DD/MM/YYYY') || ""}</td>
                <td>{momentTz(transaction.ReconDate).utc().format('DD/MM/YYYY') || ""}</td>
                <td>{transaction.Ref1 || ""}</td>
                <td>{transaction.Ref2 || ""}</td>
                <td>{transaction.LineMemo || ""}</td>
                <td>{transaction.Debit || transaction.Credit}</td>
                <td>{transaction.CashDisSum || ""}</td>
                <td>{transaction.BalDueDeb || transaction.BalDueCred }</td>
                <td>{transaction.ReconSum || "0"}</td>
                <td>{transaction.Debit || transaction.Credit}</td>
                <td>{transaction.BalDueDeb || transaction.BalDueCred }</td>
                <td>{transaction.Debit || transaction.Credit}</td>
                <td>{transaction.SYSCred || transaction.SYSDeb }</td>
                <td>{transaction.ReconNum || "0"}</td>
                <td>{transaction.ShortName || ""}</td>
                <td>{transaction.Account || ""}</td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            {/* <td className="sticky-header table-header-yellow "></td> */}
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[2].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[3].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[4].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[5].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[6].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[7].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[8].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[9].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[10].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[11].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[12].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[13].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[14].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[15].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[16].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[17].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[18].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[19].title}</td>
            {/* <td className="sticky-header table-header-yellow " style={{width:100}}></td> */}
        </tr>;
    }

    body = renderTableBody(headers, data, action);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{width: '100%'}}>
                <thead className="table-header">
                {header}
                </thead>
                <tbody>
                {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableTransactionsModal = (headers, data, action) => {

    return renderTable(headers, data, action);

}
